<template>
  <div class="body">
    <form class="form-signin text-center">
      <img class="mb-4" src="https://lm-web-assets.s3.us-east-2.amazonaws.com/img/lmc-icon.png" alt="" width="72" height="72">
      <h1 class="h3 mb-3 font-weight-normal">Sign in to L&amp;M Connect</h1>
      <label class="sr-only">Email address</label>
      <input type="email" class="form-control" placeholder="Email address" required autofocus v-model="email" autocomplete="on">
      <label class="sr-only">Password</label>
      <input type="password" class="form-control" placeholder="Password" required v-model="password" autocomplete="on">

      <button class="btn btn-lg btn-warning btn-block" type="submit" @click.prevent="login">Sign in</button>
      <p class="mt-5 mb-3 text-muted">&copy; 2020 L&amp;M Distribution and Logistics, LLC</p>
      <p class="mt-5 mb-3 text-muted">v1.02</p>
    </form>
  </div>
</template>


<script>
import auth from '@/libs/auth'
import n from '@/libs/notifications'

export default {
  data() {
    return {
      email: '',
      password: '',
    } 
  },
  methods: {
    login() {
      auth.authenticate(this.email, this.password).then(res => {

        if( res.data.ok ) {
          localStorage.token = res.data.token
          n.success("Login Successful.")
          setTimeout(() => {
            // this.$emit('auth', true, res.data.token)
            window.location = "/"
          }, 200)
        } else {
          n.error(res.data.error)
        }
      }).catch(error => {
        n.error(error)
      })
    }
  }
}
</script>

<style scoped>
html,
body {
  height: 100%;
}

.body {
  height: 100vh;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #0F1723;
  color: #fff;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}

.btn {
  background-color: #CC912F;
  color: #fff;
}

.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>